/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsConfigOciAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsConfigOciAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsConfigOciAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsConfigOciAdvisorResource>): RecommendationForFinopsConfigOciAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsConfigOciAdvisorResource(), model);
        RecommendationForFinopsConfigOciAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsConfigOciAdvisorResource>): RecommendationForFinopsConfigOciAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsConfigOciAdvisorResource.newInstance(<RecommendationForFinopsConfigOciAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsConfigOciAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsConfigOciAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsConfigOciAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsConfigOciAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
